import { forwardRef } from 'react';

import type { TextareaProps } from '@capsule/consumer-design-system';
import { Textarea } from '@capsule/consumer-design-system';

import { getIn, useFormikContext } from 'formik';

export const FormikTextarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ name, label, onBlur, onChange, ...props }, ref) => {
    const { errors, touched, values, handleBlur, handleChange } = useFormikContext();
    const error = getIn(touched, name) && getIn(errors, name);
    const value = getIn(values, name);

    return (
      <Textarea
        label={label}
        name={name}
        value={value}
        onBlur={event => {
          onBlur?.(event);
          handleBlur(event);
        }}
        onChange={event => {
          onChange?.(event);
          handleChange(event);
        }}
        error={error}
        {...props}
        ref={ref}
      />
    );
  }
);

FormikTextarea.displayName = 'FormikTextarea';
